import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../widgets/Typography';
import { RotateIcon } from '../../../assets/icons/Rotate';

interface ILastUpdatedProps {
  lastUpdatedDate?: string;
  widgetIds?: any;
  refreshWidget: () => void;
}

function LastUpdated({
  lastUpdatedDate,
  widgetIds,
  refreshWidget,
}: ILastUpdatedProps) {
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [lastUpdated, setLastUpdated] = useState<string>('');

  const { t } = useTranslation();

  const getOrdinalIndicator = (day: number): string => {
    if (day > 10 && day < 20) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const updateLastUpdatedTime = (): void => {
    const displayDate = lastUpdatedDate
      ? new Date(lastUpdatedDate)
      : new Date();
    const day = displayDate.getDate().toString().padStart(2, '0');
    const month = displayDate.toLocaleString('en-US', { month: 'short' });
    const year = displayDate.getFullYear();
    let hour = displayDate.getHours();
    const minute = displayDate.getMinutes().toString().padStart(2, '0');
    const meridian = hour < 12 ? 'AM' : 'PM';

    hour = hour % 12 || 12;

    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedDate = ` ${t(
      'LAST_UPDATED_AT',
    )} ${day} ${month}, ${year} ${t(
      'AT',
    )} ${hour}:${minute} ${meridian} (${timezoneName})`;
    setLastUpdated(formattedDate);
  };

  useEffect(() => {
    updateLastUpdatedTime();
  }, []);

  const handleRefreshClick = (): void => {
    setRefreshing(true);
    refreshWidget();
    setTimeout(() => {
      updateLastUpdatedTime();
      setRefreshing(false);
    }, 100);
  };

  return (
    <div className="flex flex-row items-center gap-1">
      {/*<div*/}
      {/*  className={`mr-2 w-7 cursor-pointer rounded-[3px] p-[6px] transition-all duration-150 hover:bg-black-200 ${*/}
      {/*    refreshing ? 'bg-black-400' : ''*/}
      {/*  }`}*/}
      {/*  role="button"*/}
      {/*  onClick={handleRefreshClick}*/}
      {/*>*/}
      {/*  <RefreshIcon*/}
      {/*    className={`${*/}
      {/*      refreshing ? 'stroke-black-900' : 'stroke-black-500'*/}
      {/*    } h-full w-full`}*/}
      {/*  />*/}
      {/*</div>*/}
      <Typography variant="body-sm" className="text-grey-700">
        {lastUpdated}
      </Typography>
      <button
        className="cursor-pointer rounded transition-transform active:rotate-90"
        onClick={handleRefreshClick}
        aria-label={t('REFRESH_DATA')}
      >
        <RotateIcon />
      </button>
    </div>
  );
}

export default LastUpdated;
